export default __webpack_public_path__ + "static/Cid-eb5429e4520b0794cd2241abcfbcde2f.svg";